import { UPDATE_MODEL_VALUE } from '../../constants';
import { type PropType } from 'vue';
import { type ComponentSizes, componentDefaultSize } from '../../constants';

export interface TabItem {
    text: string;
    value: string;
    disabled?: boolean;
}

export interface TabsProps {
    modelValue: string;
    tabs: TabItem[];
    size?: ComponentSizes;
}

export const tabsProps = {
    modelValue: {
        type: String as PropType<TabsProps['modelValue']>,
        default: undefined,
        required: true,
    },
    tabs: {
        type: Array as PropType<TabsProps['tabs']>,
        default: undefined,
        required: true,
    },
    size: {
        type: String as PropType<TabsProps['size']>,
        default: componentDefaultSize,
        required: false,
    },
};

export const tabsEmits = {
    [UPDATE_MODEL_VALUE]: (value: string) => value,
};
